import { Link } from 'react-router-dom';
import { Icon } from '@/components';

export function NotFound() {
  return (
    <div style={{ minHeight: '100dvh', background: 'var(--paper)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ textAlign: 'center', maxWidth: 360 }}>
        <div style={{ width: 56, height: 56, borderRadius: 14, background: 'var(--paper-2)', color: 'var(--ink-4)', display: 'grid', placeItems: 'center', margin: '0 auto 16px' }}>
          <Icon name="search" size={26} />
        </div>
        <h1 style={{ fontSize: 22, fontWeight: 600, margin: 0 }}>Page not found</h1>
        <p style={{ fontSize: 14, color: 'var(--ink-3)', margin: '8px 0 20px' }}>The page you're looking for doesn't exist.</p>
        <Link to="/" className="btn btn-primary btn-sm">Go home</Link>
      </div>
    </div>
  );
}
